import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const domains = [
  { icon: "ri-bar-chart-box-line", label: "Conseil en gestion" },
  { icon: "ri-compass-3-line", label: "Stratégie d'entreprise" },
  { icon: "ri-line-chart-line", label: "Optimisation des activités" },
];

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 bg-[#0A2540] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://public.readdy.ai/ai/img_res/6f0d351ee9b9d5f3c2cea8e6ca59ec17.jpg"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white/60 text-xs uppercase tracking-widest mb-6">
            À Propos
          </span>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 tracking-tight">
            BOBROWSKA
          </h1>
          <p className="text-white/60 text-xl">Conseil indépendant basé à Wisches, France</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-16 items-start">
            {/* Left: Photo + Info */}
            <div className="lg:w-2/5 flex flex-col items-center lg:items-start">
              <div className="w-full max-w-sm rounded-2xl overflow-hidden mb-8">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20female%20business%20consultant%20portrait%2C%20elegant%20and%20confident%2C%20modern%20office%20background%2C%20soft%20natural%20light%2C%20professional%20attire%2C%20warm%20smile%2C%20sophisticated%20appearance%2C%20clean%20white%20background%2C%20high%20quality%20corporate%20headshot&width=500&height=600&seq=ewa-portrait-01&orientation=portrait"
                  alt="Ewa Bobrowska"
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <h2 className="text-2xl font-bold text-[#0A2540] mb-1">Ewa Bobrowska</h2>
              <p className="text-gray-500 text-sm mb-4">Dirigeante — Entrepreneur individuel</p>
              <div className="flex flex-col gap-2 text-sm text-gray-500">
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-[#0A2540]"></i>
                  </span>
                  49 Rue, 67130 Wisches, France
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-government-line text-[#0A2540]"></i>
                  </span>
                  SIRET : 100 085 687 00018
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-briefcase-line text-[#0A2540]"></i>
                  </span>
                  Code APE : 70.22Z
                </span>
              </div>
            </div>

            {/* Right: Text */}
            <div className="flex-1">
              <span className="inline-block px-4 py-1.5 rounded-full border border-[#0A2540]/20 text-[#0A2540] text-xs uppercase tracking-widest mb-6">
                Notre histoire
              </span>
              <h3 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-6 leading-tight">
                Une activité indépendante au service des entrepreneurs
              </h3>
              <div className="flex flex-col gap-5 text-gray-500 text-base leading-relaxed">
                <p>
                  BOBROWSKA est une activité indépendante de conseil basée à Wisches, en Alsace. L&apos;entreprise est dirigée par Ewa Bobrowska, spécialisée dans le conseil en gestion et développement d&apos;activité.
                </p>
                <p>
                  Avec une approche pragmatique et personnalisée, BOBROWSKA accompagne les entrepreneurs et les dirigeants dans leurs décisions stratégiques et opérationnelles. Chaque mission est abordée avec rigueur et engagement.
                </p>
                <p>
                  L&apos;objectif est d&apos;accompagner les entrepreneurs dans leurs décisions et d&apos;améliorer la performance de leur entreprise, en proposant des solutions concrètes et adaptées à chaque situation.
                </p>
              </div>

              {/* Domains */}
              <div className="mt-10">
                <p className="text-xs uppercase tracking-widest text-gray-400 mb-5">Domaines d&apos;intervention</p>
                <div className="flex flex-col gap-3">
                  {domains.map((d) => (
                    <div key={d.label} className="flex items-center gap-4 p-4 rounded-xl bg-[#f8f9fb]">
                      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0A2540]/10">
                        <i className={`${d.icon} text-[#0A2540]`}></i>
                      </span>
                      <span className="text-[#0A2540] font-medium text-sm">{d.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Objective Card */}
      <section className="py-16 bg-[#f8f9fb]">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="bg-[#0A2540] rounded-2xl p-12 text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-5">Notre Objectif</h3>
            <p className="text-white/70 text-lg leading-relaxed">
              Accompagner les entrepreneurs dans leurs décisions et améliorer la performance de leur entreprise, en proposant des solutions concrètes, simples et adaptées à chaque situation.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white text-center">
        <div className="max-w-xl mx-auto px-6">
          <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Prêt à échanger sur votre projet ?</h3>
          <p className="text-gray-500 mb-8 text-sm leading-relaxed">
            Contactez-nous pour discuter de vos besoins et découvrir comment nous pouvons vous accompagner.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#0A2540] text-white font-semibold text-sm hover:bg-[#0d3060] transition-all duration-200 whitespace-nowrap"
          >
            Nous contacter
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
